import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopContext } from "../context/ShopContext.jsx";
import { Box, Typography, Container, Button } from '@mui/material';
import CartItem from "../components/CartItem.jsx";

const Cart = () => {
  const navigate = useNavigate();
  const { cartDetails, getCartAmount, currency } = useContext(ShopContext);
  
  const handleProceedToCheckout = () => {
    navigate('/place-order');
  };

  return (
    <Container sx={{ my: 4 }}>
      <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
        Your Cart
      </Typography>
      
      {cartDetails.length === 0 ? (
        <Typography variant="body1" align="center" sx={{ my: 4 }}>
          Your cart is empty.
        </Typography>
      ) : (
        <Box>
          {cartDetails.map((item) => (
            <CartItem key={`${item.product_id}-${item.size}`} item={item} />
          ))}
        </Box>
      )}

      {cartDetails.length > 0 && (
        <Box sx={{ mt: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>Cart Total</Typography>
          <Typography variant="body1">Subtotal: {currency}{getCartAmount()}</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleProceedToCheckout}
            sx={{ mt: 2, width: '100%' }}
          >
            Proceed to Checkout
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default Cart;
